/* eslint-disable max-len */

export default {
  confirmationHeading: '27022017-145015-7128',
  confirmationInfo: '09012026-143017-0002',
  downloadOurAppHeading: '13012016-141814-8711',
  downloadOurAppInfo: '09012026-143017-0003',
  downloadAppText1: '09012026-143017-0004',
  downloadAppText2: '09012026-143017-0005',
  downloadAppText3: '09012026-143017-0006',
  downloadAppText4: '09012026-143017-0007',
  goToHomeBtn: '02032020-112300-0040',

  freeWithYourIncludedVisit: '29092022-163625-0006',
  discount: '19122018-152801-0040',
  date: '27042016-120243-3939',
  time: '22112016-144753-8440',
  people: '18112016-101623-2917',
  taxVat: '23112016-143627-8384',

  roomBookInfoHeader: '19122018-152801-0046',
  roomBookInfoLine1: '27022019-080521-1526',
  roomBookInfoLine2: '19122018-152801-0047',
  roomBookInfoLine3: '19122018-152801-0048',
  roomBookInfoLine4: '19122018-152801-0049',

  meetingHostsInfoHeader: '19122018-152801-0050',
  meetingHostsInfoOffer: '19122018-152801-0051',
  meetingHostsInfoConfirmedText: '22022019-142905-0028',

  specialRequirementsInfoHeader: '18112016-154209-7191',
  specialRequirementsInfoOffer: '22022019-142905-0029',
  specialRequirementsInfoTextAreaLabel: '19122018-152801-0054',
  specialRequirementsInfoSendRequestButtonLabel: '19122018-152801-0055',
  specialRequirementsInfoRequestSentText: '22022019-142905-0030',
  confirmHostInfoLabel: '19122018-152801-0056',

  downloadOnTheAppStore: '19062024-092848-0025',
  getItOnGooglePlay: '18022026-121043-2481'
};
